import React from 'react';

function Vision() {
  return (
    <section className="vision">
      <div className="container">
        <h2>The TMT Learning Center: Testing an Assumption</h2>
        <div className="vision-content">
          <p>
            Here's our central question: Can the learning environment that great teachers once created
            instinctively be replicated and perpetuated, by other teachers, in other contexts, consistently?
          </p>

          <p>
            The TMT Learning Center Pilot is a 9-month experiment designed to test this. It involves working
            with 15–20 children aged 9–12 from mixed socioeconomic backgrounds, meeting 2–3 times
            per week in small groups.
          </p>

          <p>
            The pilot complements regular schooling rather than replacing it. In each session, children engage in
            guided discussions, problem-solving, hands-on exploration, and articulation of their own thinking. There
            are no grades, no rankings, no internal exams, just an environment where saying "I don't understand" is
            safe, where reasoning matters more than performance, and where learning feels joyful rather than
            intimidating.
          </p>

          <p>
            We're not measuring success through test scores. Instead, we're looking for observable shifts: greater
            comfort with unfamiliar problems, clearer articulation of thinking, resilience in the face of confusion,
            and improved engagement in regular school. If these signals are visible, the pilot has done its job.
          </p>

          <p>
            Why a 9-month pilot rather than a full school? Because this is a deliberate experiment, not an 
            institutional commitment. A small cohort, limited duration, and modest budget allow us to learn quickly, 
            adjust thoughtfully, or stop if needed, with minimal risk to children or families. Starting a full school
            from scratch would be expensive, rigid, and hard to reverse.
          </p>

          <p>
            This pilot is as much about teacher preparation and transmission as it is about children. If we can show
            that learning fluency can be cultivated, that it doesn't depend on finding another extraordinary
            individual but on creating the right conditions, then we have something others can replicate.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Vision;